import { useMemo } from "react";
import type { AnalysisStatus } from "../../../../api/useActiveAnalysesStream";
import { getAnalysisSetup } from "diagnostics-domain/setup/getSetup";
export function useImpactedAnalyses({
  setups,
  activeAnalyses,
  setupId,
  analysisStatus,
}: {
  setups: { id: string; startDate: string | null }[];
  activeAnalyses: { status: AnalysisStatus; date: number }[];
  setupId: string;
  analysisStatus: Set<AnalysisStatus>;
}) {
  return useMemo(
    () =>
      activeAnalyses.filter(
        a => analysisStatus.has(a.status) && getAnalysisSetup(setups, a)?.id === setupId,
      ),
    [activeAnalyses, setupId, setups, analysisStatus],
  );
}
